import { DefaultCell } from "app/components/React/Table/cells/DefaultCell";
import { translate } from "app/filters/i18nFilter";
import type { FlexTableColumnType } from "app/pages/sales-intelligence/types";
import { HeaderCell } from "../../../components/cells/HeaderCell/HeaderCell";

const COLUMN_DISPLAY_NAME_KEY = "si.pages.home.table-columns";

type Payload = Pick<FlexTableColumnType, "field" | "displayName" | "width"> &
    Partial<Pick<FlexTableColumnType, "cellComponent" | "headerComponent" | "format">>;

export default function createTableColumn(payload: Payload): FlexTableColumnType {
    const {
        field,
        displayName,
        format = "None",
        width,
        headerComponent = HeaderCell,
        cellComponent = DefaultCell,
    } = payload;

    return {
        field,
        displayName: displayName ?? translate(`${COLUMN_DISPLAY_NAME_KEY}.${field}`),
        headerComponent,
        cellComponent,
        type: "string",
        format,
        width,
    };
}
